import { render, staticRenderFns } from "./NewProjectView.vue?vue&type=template&id=78c8e891&scoped=true"
import script from "./NewProjectView.vue?vue&type=script&lang=ts"
export * from "./NewProjectView.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectView.vue?vue&type=style&index=0&id=78c8e891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8e891",
  null
  
)

export default component.exports